import React from "react";
import SignUp from "../components/signUp";
import LanguageSelector from "../components/language/LanguageSelector";

function CreateAccount(props) {
  return (
    <>
      <div
        className="header-ct-right"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "50px",
          paddingRight: "50px",
        }}
      >
        <LanguageSelector />
      </div>
      <SignUp />
    </>
  );
}

export default CreateAccount;
